// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6c-0";
export var startPickingButton = "_6c-1";